import React from "react";
import "./App.css";
import { AgGridReact } from "ag-grid-react";
import Moment from "moment";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  PaginationModule,
} from "ag-grid-community";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";
import { ApiService } from "../src/utils/ApiService";
import { API_URL } from "../src/utils/Constants";
import {
  CreateStudentModal,
  ModalPopUp,
  CustomRadioButton,
} from "../src/components";
import Skeleton from "@mui/material/Skeleton";
import { colors } from "./config/colors";
import PropTypes from "prop-types";
import { PRODUCT_HEADERS } from "config/constants";

class SearchAGgrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showStudentDataList: false,
      editModalMarginTop: 0,
      recordDetails: null,

      show: false,
      showPopUp: false,
      deleteStudentId: "",
      enrollmentStudentId: "",
      showAlertModal: false,
      alertModalMsg: "",
      isDeleteLoading: false,
      showReEnrollmentModal: false,
      selectedStudentData: {},
      selectedReEnrollmentOption: "",
      reEnrollmentRemarks: "",
      isViewingExistingEnrollment: false,
      enrollmentDetails: {},
      isReEnrollmentSubmitting: false,
      rejectionReasons: [],
      selectedRejectionReason: null,
      rejectionComments: "",
      showCancelEnrollmentModal: false,
      isCancellingEnrollment: false,
      studentUpdateList: [],
      studentUpdateListStudentId: "",
      studentUpdateschoolId: "",
      studentUpdateMerchantId: "",
      studentUpdateSchoolName: "",
      studentUpdateSchoolPhoneNum: "",
      studentUpdateFirstNameVal: "",
      studentUpdateLastName: "",
      studentUpdateMiddleNameVal: "",
      studentUpdateGivenName: "",
      studentUpdateEmiratesId: "",
      studentUpdateGrade: "",
      studentUpddateDivision: "",
      studentUpdateDateOfBirth: "",
      studentUpdateNationality: "",
      studentUpdateProductName: "",
      studentUpdateOutstandingAmount: "",
      studentUpdateFatherName: "",
      studentUpdateMotherName: "",
      studentUpdateParentId: "",
      studentUpdatePrimaryMobileNum: "",
      studentSecondaryMobileNum: "",
      studentUpdateEmergencyMobileNum: "",
      studentUpdateParentMobileNum3: "",
      studentUpdateOfficeNum: "",
      studentUpdateResidenceNum: "",
      studentUpdateAddress: "",
      studentUpdateEmailId1: "",
      studentUpdateEmailId2: "",
      studentUpdateEmailId3: "",
      studentUpdateEmergencyContactPerson: "",
      studentUpdateExtraField1: "",
      studentUpdateExtraField2: "",
      studentUpdateExtraField3: "",
      studentUpdateExtraField4: "",
      studentUpdateExtraField5: "",
      studentUpdateSchoolFees: "",
      studentUpdateTuitionFees: "",
      studentUpdateTransportationFees: "",
      studentUpdateCanteenFees: "",
      studentUpdateBookFees: "",
      studentUpdateEventFee: "",
      studentUpdateUniformFee: "",
      studentUpdateRegistrationFees: "",
      studentUpdateAdmissionFees: "",
      studentUpdateSchoolTripeFees: "",
      studentUpdateStationaryFees: "",
      studentUpdateMedicalFees: "",
      studentUpdateSecurityDepositFees: "",
      studentUpdateGender: "",
      studentUpdateStudentRegistered: "",
      studentUpdateId: "",
      studentUpdateStudentPrimaryKey: "",

      columnDefs: [
        {
          headerName: "Update",
          field: "id",
          colId: "view",
          pinned: "right",
          width: 160,
          cellRenderer: this.handleUpdateRow,
        },
        { headerName: "Student Id", field: "studentId" },
        { headerName: "First Name", field: "firstName" },
        { headerName: "Last Name", field: "lastName" },
        { headerName: "Given Name", field: "givenName" },
        { headerName: "Grade", field: "grade" },
        { headerName: "Date Of Birth", field: "dateOfBirth" },
        { headerName: "Nationality", field: "nationality" },
        { headerName: "Primary Mobile Number", field: "primaryMobileNum" },
        { headerName: "Emergency Mobile Number", field: "emergencyMobileNum" },
        { headerName: "Address", field: "address" },
        { headerName: "Email Id1", field: "emailId1" },
        { headerName: "Email Id2", field: "emailId2" },
        { headerName: "Email Id3", field: "emailId3" },
        {
          headerName: "Emergency Contact Person",
          field: "emergencyContactPerson",
        },
        { headerName: "Admission Fees", field: "admissionFees" },
        { headerName: "Book Fees", field: "bookFees" },
        { headerName: "Canteen Fees", field: "canteenFees" },
        { headerName: "Division", field: "division" },
        { headerName: "Event Fee", field: "eventFee" },
        { headerName: "Extra Field1", field: "extraField1" },
        { headerName: "Extra Field2", field: "extraField2" },
        { headerName: "Extra Field3", field: "extraField3" },
        { headerName: "Extra Field4", field: "extraField4" },
        { headerName: "Extra Field5", field: "extraField5" },
        { headerName: "Father Name", field: "fatherName" },
        { headerName: "Mother Name", field: "motherName" },
        { headerName: "Gender", field: "gender" },
        { headerName: "Medical Fees", field: "medicalFees" },
        { headerName: "Mobile Number", field: "mobileNum3" },
        { headerName: "Office Number", field: "mobileNum3" },
        { headerName: "Parent Id", field: "parentId" },
        { headerName: "Registration Fees", field: "registrationFees" },
        { headerName: "Residence Number", field: "residenceNum" },
        { headerName: "School Fees", field: "schoolFees" },
        { headerName: "School Id", field: "schoolId" },
        { headerName: "School Name", field: "schoolName" },
        { headerName: "School Phone Number", field: "schoolPhoneNum" },
        { headerName: "School Trip Fees", field: "schoolTripeFees" },
        { headerName: "Secondary Mobile Number", field: "secondaryMobileNum" },
        { headerName: "Security Deposit Fees", field: "securityDepositFees" },
        { headerName: "Stationary Fees", field: "stationaryFees" },
        { headerName: "Student Registered", field: "studentRegistered" },
        { headerName: "Transportation Fees", field: "transportationFees" },
        { headerName: "Tuition Fees", field: "tuitionFees" },
        { headerName: "Uniform Fee", field: "uniformFee" },
        { headerName: "Fee1", field: "fee1" },
        { headerName: "Fee2", field: "fee2" },
        { headerName: "Fee3", field: "fee3" },
        { headerName: "Fee4", field: "fee4" },
        { headerName: "Fee5", field: "fee5" },
        { headerName: "Fee6", field: "fee6" },
        { headerName: "Fee7", field: "fee7" },
        { headerName: "Fee8", field: "fee8" },
        { headerName: "Fee9", field: "fee9" },
        { headerName: "Fee10", field: "fee10" },
        { headerName: "Fee11", field: "fee11" },
        { headerName: "Fee12", field: "fee12" },
        { headerName: "Fee13", field: "fee13" },
        { headerName: "Fee14", field: "fee14" },
        { headerName: "Fee15", field: "fee15" },
        { headerName: "Fee16", field: "fee16" },
        { headerName: "Fee17", field: "fee17" },
        { headerName: "Fee18", field: "fee18" },
        { headerName: "Fee19", field: "fee19" },
        { headerName: "Fee20", field: "fee20" },
        { headerName: "Fee21", field: "fee21" },
        { headerName: "Fee22", field: "fee22" },
        { headerName: "Fee23", field: "fee23" },
        { headerName: "Fee24", field: "fee24" },
        { headerName: "Fee25", field: "fee25" },
        { headerName: "Fee26", field: "fee26" },
        { headerName: "Fee27", field: "fee27" },
        { headerName: "Fee28", field: "fee28" },
        { headerName: "Fee29", field: "fee29" },
        { headerName: "Fee30", field: "fee30" },
        { headerName: "Fee31", field: "fee31" },
        { headerName: "Fee32", field: "fee32" },
        { headerName: "Fee33", field: "fee33" },
        { headerName: "Fee34", field: "fee34" },
        { headerName: "Fee35", field: "fee35" },
        { headerName: "Fee36", field: "fee36" },
        { headerName: "Fee37", field: "fee37" },
        { headerName: "Fee38", field: "fee38" },
        { headerName: "Fee39", field: "fee39" },
        { headerName: "Fee40", field: "fee40" },
        { headerName: "Fee41", field: "fee41" },
        { headerName: "Fee42", field: "fee42" },
        { headerName: "Fee43", field: "fee43" },
        { headerName: "Fee44", field: "fee44" },
        { headerName: "Fee45", field: "fee45" },
        { headerName: "Fee46", field: "fee46" },
        { headerName: "Fee47", field: "fee47" },
        { headerName: "Fee48", field: "fee48" },
        { headerName: "Fee49", field: "fee49" },
        { headerName: "Fee50", field: "fee50" },
        { headerName: "Fee51", field: "fee51" },
        { headerName: "Fee52", field: "fee52" },
        { headerName: "Fee53", field: "fee53" },
        { headerName: "Fee54", field: "fee54" },
        { headerName: "Fee55", field: "fee55" },
        { headerName: "Fee56", field: "fee56" },
        { headerName: "Fee57", field: "fee57" },
        { headerName: "Fee58", field: "fee58" },
        { headerName: "Fee59", field: "fee59" },
        { headerName: "Fee60", field: "fee60" },
        { headerName: "Fee61", field: "fee61" },
        { headerName: "Fee62", field: "fee62" },
        { headerName: "Fee63", field: "fee63" },
        { headerName: "Fee64", field: "fee64" },
        { headerName: "Fee65", field: "fee65" },
        { headerName: "Fee66", field: "fee66" },
        { headerName: "Fee67", field: "fee67" },
        { headerName: "Fee68", field: "fee68" },
        { headerName: "Fee69", field: "fee69" },
        { headerName: "Fee70", field: "fee70" },
        { headerName: "Fee71", field: "fee71" },
        { headerName: "Fee72", field: "fee72" },
        { headerName: "Fee73", field: "fee73" },
        { headerName: "Fee74", field: "fee74" },
        { headerName: "Fee75", field: "fee75" },
        { headerName: "Fee76", field: "fee76" },
        { headerName: "Fee77", field: "fee77" },
        { headerName: "Fee78", field: "fee78" },
        { headerName: "Fee79", field: "fee79" },
        { headerName: "Fee80", field: "fee80" },
        { headerName: "Fee81", field: "fee81" },
        { headerName: "Fee82", field: "fee82" },
        { headerName: "Fee83", field: "fee83" },
        { headerName: "Fee84", field: "fee84" },
        { headerName: "Fee85", field: "fee85" },
        { headerName: "Fee86", field: "fee86" },
        { headerName: "Fee87", field: "fee87" },
        { headerName: "Fee88", field: "fee88" },
        { headerName: "Fee89", field: "fee89" },
        { headerName: "Fee90", field: "fee90" },
        { headerName: "Fee91", field: "fee91" },
        { headerName: "Fee92", field: "fee92" },
        { headerName: "Fee93", field: "fee93" },
        { headerName: "Fee94", field: "fee94" },
        { headerName: "Fee95", field: "fee95" },
        { headerName: "Fee96", field: "fee96" },
        { headerName: "Fee97", field: "fee97" },
        { headerName: "Fee98", field: "fee98" },
        { headerName: "Fee99", field: "fee99" },
        { headerName: "Fee100", field: "fee100" },
        { headerName: "Fee101", field: "fee101" },
        { headerName: "Fee102", field: "fee102" },
        { headerName: "Fee103", field: "fee103" },
        { headerName: "Fee104", field: "fee104" },
        { headerName: "Fee105", field: "fee105" },
        { headerName: "Fee106", field: "fee106" },
        { headerName: "Fee107", field: "fee107" },
        { headerName: "Fee108", field: "fee108" },
        { headerName: "Fee109", field: "fee109" },
        { headerName: "Fee110", field: "fee110" },
        { headerName: "Fee111", field: "fee111" },
        { headerName: "Fee112", field: "fee112" },
        { headerName: "Fee113", field: "fee113" },
        { headerName: "Fee114", field: "fee114" },
        { headerName: "Fee115", field: "fee115" },
        { headerName: "Fee116", field: "fee116" },
        { headerName: "Fee117", field: "fee117" },
        { headerName: "Fee118", field: "fee118" },
        { headerName: "Fee119", field: "fee119" },
        { headerName: "Fee120", field: "fee120" },
        { headerName: "Fee121", field: "fee121" },
        { headerName: "Fee122", field: "fee122" },
        { headerName: "Fee123", field: "fee123" },
        { headerName: "Fee124", field: "fee124" },
        { headerName: "Fee125", field: "fee125" },
        { headerName: "Fee126", field: "fee126" },
        { headerName: "Fee127", field: "fee127" },
        { headerName: "Fee128", field: "fee128" },
        { headerName: "Fee129", field: "fee129" },
        { headerName: "Fee130", field: "fee130" },
        { headerName: "Fee131", field: "fee131" },
        { headerName: "Fee132", field: "fee132" },
        { headerName: "Fee133", field: "fee133" },
        { headerName: "Fee134", field: "fee134" },
        { headerName: "Fee135", field: "fee135" },
        { headerName: "Fee136", field: "fee136" },
        { headerName: "Fee137", field: "fee137" },
        { headerName: "Fee138", field: "fee138" },
        { headerName: "Fee139", field: "fee139" },
        { headerName: "Fee140", field: "fee140" },
        { headerName: "Fee141", field: "fee141" },
        { headerName: "Fee142", field: "fee142" },
        { headerName: "Fee143", field: "fee143" },
        { headerName: "Fee144", field: "fee144" },
        { headerName: "Fee145", field: "fee145" },
        { headerName: "Fee146", field: "fee146" },
        { headerName: "Fee147", field: "fee147" },
        { headerName: "Fee148", field: "fee148" },
        { headerName: "Fee149", field: "fee149" },
        { headerName: "Fee150", field: "fee150" },
        { headerName: "Fee151", field: "fee151" },
        { headerName: "Fee152", field: "fee152" },
        { headerName: "Fee153", field: "fee153" },
        { headerName: "Fee154", field: "fee154" },
        { headerName: "Fee155", field: "fee155" },
        { headerName: "Fee156", field: "fee156" },
        { headerName: "Fee157", field: "fee157" },
        { headerName: "Fee158", field: "fee158" },
        { headerName: "Fee159", field: "fee159" },
        { headerName: "Fee160", field: "fee160" },
        { headerName: "Fee161", field: "fee161" },
        { headerName: "Fee162", field: "fee162" },
        { headerName: "Fee163", field: "fee163" },
        { headerName: "Fee164", field: "fee164" },
        { headerName: "Fee165", field: "fee165" },
        { headerName: "Fee166", field: "fee166" },
        { headerName: "Fee167", field: "fee167" },
        { headerName: "Fee168", field: "fee168" },
        { headerName: "Fee169", field: "fee169" },
        { headerName: "Fee170", field: "fee170" },
        { headerName: "Fee171", field: "fee171" },
        { headerName: "Fee172", field: "fee172" },
        { headerName: "Fee173", field: "fee173" },
        { headerName: "Fee174", field: "fee174" },
        { headerName: "Fee175", field: "fee175" },
        { headerName: "Fee176", field: "fee176" },
        { headerName: "Fee177", field: "fee177" },
        { headerName: "Fee178", field: "fee178" },
        { headerName: "Fee179", field: "fee179" },
        { headerName: "Fee180", field: "fee180" },
        { headerName: "Fee181", field: "fee181" },
        { headerName: "Fee182", field: "fee182" },
        { headerName: "Fee183", field: "fee183" },
        { headerName: "Fee184", field: "fee184" },
        { headerName: "Fee185", field: "fee185" },
        { headerName: "Fee186", field: "fee186" },
        { headerName: "Fee187", field: "fee187" },
        { headerName: "Fee188", field: "fee188" },
        { headerName: "Fee189", field: "fee189" },
        { headerName: "Fee190", field: "fee190" },
        { headerName: "Fee191", field: "fee191" },
        { headerName: "Fee192", field: "fee192" },
        { headerName: "Fee193", field: "fee193" },
        { headerName: "Fee194", field: "fee194" },
        { headerName: "Fee195", field: "fee195" },
        { headerName: "Fee196", field: "fee196" },
        { headerName: "Fee197", field: "fee197" },
        { headerName: "Fee198", field: "fee198" },
        { headerName: "Fee199", field: "fee199" },
        { headerName: "Fee200", field: "fee200" },
        { headerName: "recurringFeesEnabled", field: "recurringFeesEnabled" },
        { headerName: "customProducts", field: "customProducts" },
        { headerName: "enrollmentFees", field: "enrollmentFees" },
      ],
      paginationPageSize: 20,
      rowData: [
        {
          schoolId: 0,
          studentId: "string",
          merchantId: "string",
          schoolName: "string",
          schoolPhoneNum: 0,
          firstName: "string",
          middleName: "string",
          lastName: "string",
          givenName: "string",
          emiratesId: "string",
          grade: "string",
          division: "string",
          dateOfBirth: "string",
          nationality: "string",
          productName: "string",
          outstandingAmount: "string",
          fatherName: "string",
          motherName: "string",
          parentId: "string",
          primaryMobileNum: "string",
          emergencyMobileNum: 0,
          parentMobileNum3: 0,
          officeNum: 0,
          residenceNum: 0,
          address: "string",
          emailId1: "string",
          emailId2: "string",
          emailId3: "string",
          emergencyContactPerson: "string",
          extraField1: "string",
          extraField2: "string",
          extraField3: "string",
          extraField4: "string",
          extraField5: "string",
          schoolFees: 0.0,
          tuitionFees: 0.0,
          transportationFees: 0.0,
          canteenFees: 0.0,
          bookFees: 0.0,
          eventFee: 0.0,
          uniformFee: 0.0,
          registrationFees: 0.0,
          admissionFees: 0.0,
          schoolTripeFees: 0.0,
          stationaryFees: 0.0,
          medicalFees: 0.0,
          securityDepositFees: 0.0,
          gender: "string",
          studentRegistered: false,
          fee1: "",
          fee2: "",
          fee3: "",
          fee4: "",
          fee5: "",
          fee6: "",
          fee7: "",
          fee8: "",
          fee9: "",
          fee10: "",
          fee11: "",
          fee12: "",
          fee13: "",
          fee14: "",
          fee15: "",
          fee16: "",
          fee17: "",
          fee18: "",
          fee19: "",
          fee20: "",
          fee21: "",
          fee22: "",
          fee23: "",
          fee24: "",
          fee25: "",
          fee26: "",
          fee27: "",
          fee28: "",
          fee29: "",
          fee30: "",
          fee31: "",
          fee32: "",
          fee33: "",
          fee34: "",
          fee35: "",
          fee36: "",
          fee37: "",
          fee38: "",
          fee39: "",
          fee40: "",
          fee41: "",
          fee42: "",
          fee43: "",
          fee44: "",
          fee45: "",
          fee46: "",
          fee47: "",
          fee48: "",
          fee49: "",
          fee50: "",
          fee51: "",
          fee52: "",
          fee53: "",
          fee54: "",
          fee55: "",
          fee56: "",
          fee57: "",
          fee58: "",
          fee59: "",
          fee60: "",
          fee61: "",
          fee62: "",
          fee63: "",
          fee64: "",
          fee65: "",
          fee66: "",
          fee67: "",
          fee68: "",
          fee69: "",
          fee70: "",
          fee71: "",
          fee72: "",
          fee73: "",
          fee74: "",
          fee75: "",
          fee76: "",
          fee77: "",
          fee78: "",
          fee79: "",
          fee80: "",
          fee81: "",
          fee82: "",
          fee83: "",
          fee84: "",
          fee85: "",
          fee86: "",
          fee87: "",
          fee88: "",
          fee89: "",
          fee90: "",
          fee91: "",
          fee92: "",
          fee93: "",
          fee94: "",
          fee95: "",
          fee96: "",
          fee97: "",
          fee98: "",
          fee99: "",
          fee100: "",
          fee101: "",
          fee102: "",
          fee103: "",
          fee104: "",
          fee105: "",
          fee106: "",
          fee107: "",
          fee108: "",
          fee109: "",
          fee110: "",
          fee111: "",
          fee112: "",
          fee113: "",
          fee114: "",
          fee115: "",
          fee116: "",
          fee117: "",
          fee118: "",
          fee119: "",
          fee120: "",
          fee121: "",
          fee122: "",
          fee123: "",
          fee124: "",
          fee125: "",
          fee126: "",
          fee127: "",
          fee128: "",
          fee129: "",
          fee130: "",
          fee131: "",
          fee132: "",
          fee133: "",
          fee134: "",
          fee135: "",
          fee136: "",
          fee137: "",
          fee138: "",
          fee139: "",
          fee140: "",
          fee141: "",
          fee142: "",
          fee143: "",
          fee144: "",
          fee145: "",
          fee146: "",
          fee147: "",
          fee148: "",
          fee149: "",
          fee150: "",
          fee151: "",
          fee152: "",
          fee153: "",
          fee154: "",
          fee155: "",
          fee156: "",
          fee157: "",
          fee158: "",
          fee159: "",
          fee160: "",
          fee161: "",
          fee162: "",
          fee163: "",
          fee164: "",
          fee165: "",
          fee166: "",
          fee167: "",
          fee168: "",
          fee169: "",
          fee170: "",
          fee171: "",
          fee172: "",
          fee173: "",
          fee174: "",
          fee175: "",
          fee176: "",
          fee177: "",
          fee178: "",
          fee179: "",
          fee180: "",
          fee181: "",
          fee182: "",
          fee183: "",
          fee184: "",
          fee185: "",
          fee186: "",
          fee187: "",
          fee188: "",
          fee189: "",
          fee190: "",
          fee191: "",
          fee192: "",
          fee193: "",
          fee194: "",
          fee195: "",
          fee196: "",
          fee197: "",
          fee198: "",
          fee199: "",
          fee200: "",
          recurringFeesEnabled: false,
          customProducts: "",
          enrollmentFees: "",
        },
      ],
      suppressMenuHide: true,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleUpdateRow = this.handleUpdateRow.bind(this);
  }

  componentDidMount() {
    $(".ag-cell").text("School Id").hide();
  }

  handleUpdateRow = (params) => {
    const handleShowEdit = () => this.handleShow(params.data.studentId);
    const handleShowDelete = () => this.handleShowDelete(params.data.studentId);
    const handleCheckReEnrollmentStatus = () =>
      this.handleCheckReEnrollmentStatus(params.data);
    const isSalesAdmin = localStorage.getItem("role") == "SALESADMIN";
    return isSalesAdmin ? (
      <div className="row">
        <div disabled="disabled" className="edit_button_disable"></div>
        <div disabled="disabled" className="delete_button_disable"></div>
      </div>
    ) : (
      <div className="row">
        <div
          className="edit_button"
          style={{ marginTop: 4, height: 40, width: 40 }}
          onClick={handleShowEdit}
          disabled="false"
        ></div>
        {/* <div disabled="disabled" className="delete_button_disable"></div> */}
        <div
          className="delete_button"
          style={{ marginTop: 4, height: 40, width: 40 }}
          onClick={handleShowDelete}
          disabled="false"
        ></div>
        <div
          className="reenrollment_button"
          style={{ marginTop: 4, height: 24, width: 24 }}
          onClick={handleCheckReEnrollmentStatus}
          disabled="false"
          title="Check Re-enrollment Status"
        ></div>
      </div>
    );
  };

  handleClose() {
    this.setState({ show: false });
  }

  handleShow = (idVal) => {
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (roleData == "SUPERADMIN") {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData == "SCHOOLADMIN") {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }
    let shoolIdClicked = idVal;
    let authCode = localStorage.getItem("bearer");
    let studentUrl = localStorage.getItem("studentDataUrl");
    let url = studentUrl + "/getone";
    let data = {
      schoolId: merchantIdGlobal,
      studentId: shoolIdClicked,
    };

    fetch(url, {
      method: "POST", // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json",
        Authorization: authCode,
        "X-Auth-Token": "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
      },
    })
      .then((res) => {
        const auth = res.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return res.json();
      })
      .then((response) => {
        if (response.status.code === "Y") {
          this.setState({ recordDetails: response.body[0], show: true });
        }
        if (response.status.code === "N") {
          this.setState({ showStudentDataList: true });
        }
      });
  };

  handleCheckReEnrollmentStatus = async (selectedStudentData) => {
    try {
       let roleData = localStorage.getItem("role");
      let merchantIdGlobal = "";
      if (roleData == "SUPERADMIN") {
        merchantIdGlobal = localStorage.getItem("globalMerchantId");
      }
      if (roleData == "SCHOOLADMIN") {
        merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
      }
      const resp = await ApiService.getRequest(
        `${API_URL.ENROLLMENT_STATUS}${selectedStudentData.studentId}?merchantId=${merchantIdGlobal}`,
        PRODUCT_HEADERS,
      );
      if (resp.status.code === "Y") {
        if (resp.body && Object.keys(resp.body).length > 0) {
          // Existing enrollment found, show details
          this.setState({
            showReEnrollmentModal: true,
            selectedStudentData: selectedStudentData,
            isViewingExistingEnrollment: true,
            enrollmentDetails: resp.body,
            selectedReEnrollmentOption: "",
            reEnrollmentRemarks: "",
          });
        } else {
          // No existing enrollment, show radio buttons for new request
          this.setState({
            showReEnrollmentModal: true,
            selectedStudentData: selectedStudentData,
            isViewingExistingEnrollment: false,
            enrollmentDetails: {},
            selectedReEnrollmentOption: "",
            reEnrollmentRemarks: "",
          });
        }
      } else {
        this.setState({
          showReEnrollmentModal: true,
          selectedStudentData: selectedStudentData,
          isViewingExistingEnrollment: false,
          enrollmentDetails: {},
          alertModalMsg:
            resp.status.message || "Failed to check re-enrollment status",
        });
      }
    } catch (err) {
      this.setState({
        showReEnrollmentModal: true,
        selectedStudentData: selectedStudentData,
        isViewingExistingEnrollment: false,
        enrollmentDetails: {},
        alertModalMsg:
          "Failed to check re-enrollment status. Please try again.",
      });
    }
  };

  handleShowDelete = (studentId) => {
    this.setState({ showPopUp: true, deleteStudentId: studentId });
  };

  onHideUpdateOnFailure = () => {
    this.setState({ show: false, showPopUp: false, isDeleteLoading: false });
  };

  onCancelDelete = () => {
    this.setState({ showPopUp: false });
  };

  onConfirmDelete = async () => {
    try {
      this.setState({ isDeleteLoading: true });
      let roleData = localStorage.getItem("role");
      let merchantIdGlobal = "";
      if (roleData == "SUPERADMIN") {
        merchantIdGlobal = localStorage.getItem("globalMerchantId");
      }
      if (roleData == "SCHOOLADMIN") {
        merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
      }
      const payload = {
        schoolId: merchantIdGlobal,
        existingStudentIds: [this.state.deleteStudentId],
      };
      const resp = await ApiService.postRequest(API_URL.SINGLE_DELETE, payload);
      if (resp.status.code === "N") {
        this.setState({
          showAlertModal: true,
          alertModalMsg: resp.status.message,
          showPopUp: false,
          isDeleteLoading: false,
        });
      } else {
        this.setState({
          show: false,
          showPopUp: false,
          isDeleteLoading: false,
          showAlertModal: true,
          alertModalMsg: resp.body,
        });
        this.props.funcGetList();
      }
    } catch (err) {
      console.error(err);
    }
  };

  onHideAlertModal = () => {
    this.setState({ showAlertModal: false, alertModalMsg: "" });
  };

  onHideReEnrollmentModal = () => {
    this.setState({
      showReEnrollmentModal: false,
      reEnrollmentStudentId: "",
      selectedReEnrollmentOption: "",
      reEnrollmentRemarks: "",
      isViewingExistingEnrollment: false,
      enrollmentDetails: {},
      rejectionReasons: [],
      selectedRejectionReason: null,
      rejectionComments: "",
      showCancelEnrollmentModal: false,
    });
  };

  handleShowCancelEnrollmentModal = () => {
    this.setState({ showCancelEnrollmentModal: true });
  };

  handleHideCancelEnrollmentModal = () => {
    this.setState({ showCancelEnrollmentModal: false });
  };

  handleCancelEnrollment = async () => {
    try {
      this.setState({ isCancellingEnrollment: true });
      const resp = await ApiService.postRequest(
        API_URL.CANCEL_ENROLLMENT,
        {
          enrollmentId: this.state.enrollmentDetails.id,
        },
        PRODUCT_HEADERS
      );
      
      if (resp.status.code === "Y") {
        this.setState({
          showCancelEnrollmentModal: false,
          showReEnrollmentModal: false,
          isCancellingEnrollment: false,
          showAlertModal: true,
          alertModalMsg: "Enrollment cancelled successfully",
          enrollmentDetails: {},
        });
      } else {
        this.setState({
          showAlertModal: true,
          alertModalMsg: resp.status.message || "Failed to cancel enrollment",
          isCancellingEnrollment: false,
          showCancelEnrollmentModal: false,
        });
      }
    } catch (err) {
      this.setState({
        showAlertModal: true,
        alertModalMsg: "Failed to cancel enrollment. Please try again.",
        isCancellingEnrollment: false,
        showCancelEnrollmentModal: false,
      });
    }
  };

  handleReEnrollmentOptionChange = (option) => {
    this.setState({ selectedReEnrollmentOption: option }, () => {
      if (option === "Parent doesn't want to re-enroll") {
        this.fetchRejectionReasons();
      }
    });
  };

  fetchRejectionReasons = async () => {
    try {
      const resp = await ApiService.getRequest(API_URL.SKIPLY_EXTERNAL_PRODUCTS, PRODUCT_HEADERS);
      if (resp.status.code === "Y" && resp.body?.reEnrollments) {
        let roleData = localStorage.getItem("role");
        let merchantIdGlobal = "";
        if (roleData == "SUPERADMIN") {
          merchantIdGlobal = localStorage.getItem("globalMerchantId");
        }
        if (roleData == "SCHOOLADMIN") {
          merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
        }

        const merchantReEnrollments = resp.body.reEnrollments.find(
          item => item.merchantId === merchantIdGlobal
        );

        if (merchantReEnrollments?.rejectionReason) {
          this.setState({ rejectionReasons: merchantReEnrollments.rejectionReason });
        }
      }
    } catch (err) {
      console.error("Error fetching rejection reasons:", err);
    }
  };

  handleRejectionReasonChange = (reason) => {
    this.setState({ selectedRejectionReason: reason });
  };

  handleRejectionCommentsChange = (e) => {
    this.setState({ rejectionComments: e.target.value });
  };

  handleReEnrollmentRemarksChange = (e) => {
    this.setState({ reEnrollmentRemarks: e.target.value });
  };

  handleReEnrollmentSubmit = async () => {
    this.setState({ isReEnrollmentSubmitting: true });
    try {
      let roleData = localStorage.getItem("role");
      let merchantIdGlobal = "";
      if (roleData == "SUPERADMIN") {
        merchantIdGlobal = localStorage.getItem("globalMerchantId");
      }
      if (roleData == "SCHOOLADMIN") {
        merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
      }

      let payload;
      if (this.state.selectedReEnrollmentOption === "Parent would like to re-enroll") {
        payload = {
          studentIds: [this.state.selectedStudentData.studentId],
          merchantId: merchantIdGlobal,
          remarks: this.state.reEnrollmentRemarks,
        };
      } else if (this.state.selectedReEnrollmentOption === "Parent doesn't want to re-enroll") {
        const selectedReason = this.state.rejectionReasons.find(r => r.id === this.state.selectedRejectionReason);
        const getRejectionComments = () => {
          if (selectedReason?.requiresComment) {
            return this.state.rejectionComments;
          }
          return selectedReason?.title || '';
        };

        payload = {
          studentIds: [this.state.selectedStudentData.studentId],
          merchantId: merchantIdGlobal,
          rejectionComments: getRejectionComments(),
        };
      }

      // Assuming there's an API endpoint for re-enrollment
      const resp = await ApiService.postRequest(
         this.state.selectedReEnrollmentOption === "Parent doesn't want to re-enroll" ? API_URL.RE_ENROLLMENT_REJECT :
        API_URL.RE_ENROLLMENT_ACCEPT,
        payload,
        PRODUCT_HEADERS,
      );

      if (resp.status.code === "Y") {
        this.setState({
          showReEnrollmentModal: false,
          showAlertModal: true,
          alertModalMsg: "Re-enrollment request submitted successfully",
          reEnrollmentStudentId: "",
          selectedReEnrollmentOption: "",
          reEnrollmentRemarks: "",
          rejectionReasons: [],
          selectedRejectionReason: null,
          rejectionComments: "",
          isReEnrollmentSubmitting: false,
        });
      } else {
        this.setState({
          showAlertModal: true,
          alertModalMsg:
            resp.status.message || "Failed to submit re-enrollment request",
          isReEnrollmentSubmitting: false,
        });
      }
    } catch (err) {
      this.setState({
        showAlertModal: true,
        alertModalMsg:
          "Failed to submit re-enrollment request. Please try again.",
        isReEnrollmentSubmitting: false,
      });
    }
  };

  onPageSizeChanged(newPageSize) {
    var value = document.getElementById("page-size").value;
    this.gridApi.paginationSetPageSize(Number(value));
  }

  renderStudentTable() {
    if (this.props.isLoading) {
      return <Skeleton variant="rect" width={"100%"} height={400} />;
    }
    return (
      <div style={{ height: "500px" }}>
        <AgGridReact
          modules={[
            ClientSideRowModelModule,
            ValidationModule,
            RowSelectionModule,
            TextFilterModule,
            NumberFilterModule,
            DateFilterModule,
            CustomFilterModule,
            PaginationModule,
          ]}
          columnDefs={this.state.columnDefs}
          suppressMenuHide={true}
          rowData={this.props.studentDetails}
        />
      </div>
    );
  }

  renderEditStudentModal() {
    return (
      <CreateStudentModal
        show={this.state.show}
        handleHide={this.onHideUpdateOnFailure}
        recordDetails={this.state.recordDetails}
        type="update"
      />
    );
  }

  renderDeleteConfirmationPopup() {
    return (
      <Modal
        centered
        className="popUpModalModify"
        show={this.state.showPopUp}
        onHide={this.onCancelDelete}
        dialogClassName="modal-20w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton onHide={this.onCancelDelete}>
          <Modal.Title>Delete the record?</Modal.Title>
        </Modal.Header>
        <div
          style={{ textAlign: "center", width: "90%" }}
          className="modal-body"
        >
          This will permanently delete the selected student record in the
          system.
        </div>
        <Modal.Footer style={{ border: 0, justifyContent: "center" }}>
          <Button
            style={{ width: "40%", backgroundColor: "#D8D8D8", color: "black" }}
            variant="secondary"
            onClick={this.onCancelDelete}
          >
            Cancel
          </Button>
          <Button
            style={{
              width: "40%",
              backgroundColor: colors.primary,
              color: "white",
            }}
            variant="secondary"
            disabled={this.state.isDeleteLoading}
            onClick={this.onConfirmDelete}
          >
            {this.state.isDeleteLoading ? "Deleting…" : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderModalPopup() {
    return (
      <ModalPopUp
        isVisible={this.state.showAlertModal}
        title="Information"
        bodyMsg={this.state.alertModalMsg}
        onHide={this.onHideAlertModal}
      />
    );
  }

  renderReEnrollmentModal() {
    if (this.state.isViewingExistingEnrollment) {
      const isCompleted = this.state.enrollmentDetails.enrollmentStatus === "COMPLETED";
      const canCancel = this.state.enrollmentDetails.enrollmentStatus === "ACCEPTED" || 
                       this.state.enrollmentDetails.enrollmentStatus === "REJECTED";
      
      // View existing enrollment details
      return (
        <Modal
          show={this.state.showReEnrollmentModal}
          onHide={this.onHideReEnrollmentModal}
          centered
          size="md"
          className="popUpModalModify"
        >
          <Modal.Header closeButton>
            <Modal.Title>Enrollment Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="mb-3"
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              {isCompleted ? "Re-enrollment is already completed" : "Re-enrollment Status"}
            </div>
            {/* Student Information Section */}
            <div
              className="mb-2 p-3 border rounded"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <div className="mb-2" style={{ fontWeight: "bold" }}>
                Student Information
              </div>
              <div>
                Name: {this.state.selectedStudentData.firstName}{" "}
                {this.state.selectedStudentData.lastName}
              </div>
              <div>Student ID: {this.state.selectedStudentData.studentId}</div>
              <div>Grade: {this.state.selectedStudentData.grade}</div>
            </div>

            {/* Enrollment Details Section */}
            <div className="mb-2 p-3">
              <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Status:</span>
                <strong>{this.state.enrollmentDetails.enrollmentStatus}</strong>
              </div>
              <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Date:</span>
                <strong>{Moment(this.state.enrollmentDetails.createdDate).format("DD MMMM YYYY")}</strong>
              </div>
              <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Source:</span>
                <strong>{this.state.enrollmentDetails.source}</strong>
              </div>
              
              {/* Payment Info for Completed Status */}
              {isCompleted && this.state.enrollmentDetails.paymentInfo && (
                <div className="mt-3">
                  <div className="mb-2" style={{ fontWeight: "bold", borderTop: "1px solid #ddd", paddingTop: "10px" }}>
                    Payment Information
                  </div>
                  <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Amount:</span>
                    <strong>AED {this.state.enrollmentDetails.paymentInfo.amount?.toFixed(2)}</strong>
                  </div>
                  <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>RRN:</span>
                    <strong>{this.state.enrollmentDetails.paymentInfo.rrn}</strong>
                  </div>
                  <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Payment Date:</span>
                    <strong>{Moment(this.state.enrollmentDetails.paymentInfo.paymentDate).format("DD MMMM YYYY, h:mm A")}</strong>
                  </div>
                </div>
              )}
              
              {this.state.enrollmentDetails.remarks && (
                <div className="mt-3">
                  <div>Remarks</div>
                  <strong>{this.state.enrollmentDetails.remarks}</strong>
                </div>
              )}
              {this.state.enrollmentDetails.rejectionComments && (
                <div className="mt-3">
                  <div>Rejection Comments</div>
                  <strong>{this.state.enrollmentDetails.rejectionComments}</strong>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer style={{ border: 0, justifyContent: "center" }}>
            {canCancel && (
              <Button
                style={{
                  width: "40%",
                  backgroundColor: "#dc3545",
                  color: "white",
                }}
                variant="danger"
                onClick={this.handleShowCancelEnrollmentModal}
              >
                Cancel
              </Button>
            )}
            <Button
              style={{
                width: canCancel ? "40%" : "60%",
                backgroundColor: colors.primary,
                color: "white",
              }}
              variant="secondary"
              onClick={this.onHideReEnrollmentModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      );
    } else {
      // New re-enrollment request
      const reEnrollmentOptions = [
        {
          header: "Parent would like to re-enroll",
          description: "Parent has requested to re-enroll their child",
          fieldName: "Parent would like to re-enroll",
          color: "green",
        },
        {
          header: "Parent doesn't want to re-enroll",
          description: "Parent has declined re-enrollment for their child",
          fieldName: "Parent doesn't want to re-enroll",
          color: "red",
        },
      ];

      return (
        <Modal
          show={this.state.showReEnrollmentModal}
          onHide={this.onHideReEnrollmentModal}
          centered
          size="md"
          className="popUpModalModify"
        >
          <Modal.Header closeButton>
            <Modal.Title>Re-enrollment Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Student Information Section */}
            <div
              className="mb-2 p-3 border rounded"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <div className="mb-2">Student Information</div>
              <div>
                Name: {this.state.selectedStudentData.firstName}{" "}
                {this.state.selectedStudentData.lastName}
              </div>
              <div>Student ID: {this.state.selectedStudentData.studentId}</div>
              <div>Grade: {this.state.selectedStudentData.grade}</div>
            </div>

            {/* Re-enrollment Options */}
            <div className="mb-3">
              <div className="d-flex flex-column gap-2 w-100">
                {reEnrollmentOptions.map((option) => (
                  <CustomRadioButton
                    key={option.header}
                    label={
                      <div
                        className="d-flex flex-column gap-1 w-100"
                        style={{ textAlign: "left" }}
                      >
                        <span
                          style={{ fontWeight: "600", color: option.color }}
                        >
                          {option.header}
                        </span>
                        <span style={{ fontSize: "14px", color: "#666" }}>
                          {option.description}
                        </span>
                      </div>
                    }
                    isChecked={
                      this.state.selectedReEnrollmentOption === option.fieldName
                    }
                    onClick={() =>
                      this.handleReEnrollmentOptionChange(option.fieldName)
                    }
                  />
                ))}
              </div>
            </div>
            {this.state.selectedReEnrollmentOption && (
              <div className="mb-3">
                {this.state.selectedReEnrollmentOption === "Parent would like to re-enroll" ? (
                  <>
                    <label htmlFor="reEnrollmentRemarks" className="form-label">
                        Remarks (Required):
                    </label>
                    <textarea
                      className="form-control"
                      id="reEnrollmentRemarks"
                      rows="3"
                      value={this.state.reEnrollmentRemarks}
                      onChange={this.handleReEnrollmentRemarksChange}
                      placeholder="Enter remarks..."
                    />
                  </>
                ) : this.state.selectedReEnrollmentOption === "Parent doesn't want to re-enroll" ? (
                  <>
                    <label className="form-label">Rejection Reason:</label>
                    <div className="mb-3">
                      {this.state.rejectionReasons.length > 0 ? (
                        <div className="d-flex flex-column gap-2">
                          {this.state.rejectionReasons.map((reason) => (
                            <CustomRadioButton
                              key={reason.id}
                              label={reason.title}
                              isChecked={this.state.selectedRejectionReason === reason.id}
                              onClick={() => this.handleRejectionReasonChange(reason.id)}
                            />
                          ))}
                        </div>
                      ) : (
                        <div className="text-muted">Loading rejection reasons...</div>
                      )}
                    </div>
                    {this.state.selectedRejectionReason && 
                     this.state.rejectionReasons.find(r => r.id === this.state.selectedRejectionReason)?.requiresComment && (
                      <>
                        <label htmlFor="rejectionComments" className="form-label">
                          Comments (Required):
                        </label>
                        <textarea
                          className="form-control"
                          id="rejectionComments"
                          rows="3"
                          value={this.state.rejectionComments || ""}
                          onChange={this.handleRejectionCommentsChange}
                          placeholder="Please provide additional details..."
                          required
                        />
                      </>
                    )}
                  </>
                ) : null}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ border: 0, justifyContent: "center" }}>
            <Button
              style={{
                width: "40%",
                backgroundColor: "#D8D8D8",
                color: "black",
              }}
              variant="secondary"
              onClick={this.onHideReEnrollmentModal}
            >
              Cancel
            </Button>
            <Button
              style={{
                width: "40%",
                backgroundColor: colors.primary,
                color: "white",
              }}
              variant="secondary"
              disabled={
                !this.state.selectedReEnrollmentOption ||
                (this.state.selectedReEnrollmentOption === "Parent would like to re-enroll" && !this.state.reEnrollmentRemarks.trim()) ||
                (this.state.selectedReEnrollmentOption === "Parent doesn't want to re-enroll" && 
                 (!this.state.selectedRejectionReason || 
                  (this.state.rejectionReasons.find(r => r.id === this.state.selectedRejectionReason)?.requiresComment && 
                   !this.state.rejectionComments?.trim()))) ||
                this.state.isReEnrollmentSubmitting
              }
              onClick={this.handleReEnrollmentSubmit}
            >
              {this.state.isReEnrollmentSubmitting ? "Submitting…" : "Submit"}
            </Button>
          </Modal.Footer>
        </Modal>
      );
    }
  }

  renderCancelEnrollmentModal() {
    return (
      <Modal
        centered
        className="popUpModalModify"
        show={this.state.showCancelEnrollmentModal}
        onHide={this.handleHideCancelEnrollmentModal}
        dialogClassName="modal-20w"
        aria-labelledby="cancel-enrollment-modal"
      >
        <Modal.Header closeButton onHide={this.handleHideCancelEnrollmentModal}>
          <Modal.Title>Cancel Enrollment</Modal.Title>
        </Modal.Header>
        <div
          style={{ textAlign: "center", width: "90%" }}
          className="modal-body"
        >
          Do you want to cancel your enrollment?
        </div>
        <Modal.Footer style={{ border: 0, justifyContent: "center" }}>
          <Button
            style={{ width: "40%", backgroundColor: "#D8D8D8", color: "black" }}
            variant="secondary"
            onClick={this.handleHideCancelEnrollmentModal}
            disabled={this.state.isCancellingEnrollment}
          >
            No
          </Button>
          <Button
            style={{
              width: "40%",
              backgroundColor: "#dc3545",
              color: "white",
            }}
            variant="danger"
            disabled={this.state.isCancellingEnrollment}
            onClick={this.handleCancelEnrollment}
          >
            {this.state.isCancellingEnrollment ? "Cancelling…" : "Yes, Cancel"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    return (
      <div>
        {this.renderStudentTable()}
        {this.renderEditStudentModal()}
        {this.renderDeleteConfirmationPopup()}
        {this.renderModalPopup()}
        {this.renderReEnrollmentModal()}
        {this.renderCancelEnrollmentModal()}
      </div>
    );
  }
}

SearchAGgrid.defaultProps = {
  studentDetails: [],
};

SearchAGgrid.propTypes = {
  studentDetails: PropTypes.array,
};

export default SearchAGgrid;
